import { Header } from '@/components/Header'
import { CaseClosedIcon } from '@/components/icons/CaseClosedIcon'
import { getSlugTranslation } from '@/locale/utils'

export const CaseClosed = () => {
  return (
    <>
      <Header />
      <div className="flex flex-col items-center justify-center gap-14 p-4 pt-14">
        <div className="flex flex-col items-center gap-4">
          <CaseClosedIcon />
          <h2 className="font-bold">{getSlugTranslation('case_closed.consultation_completed')}</h2>
        </div>

        <p
          className="text-center"
          dangerouslySetInnerHTML={{
            __html: getSlugTranslation('case_closed.description')
          }}
        />
      </div>
    </>
  )
}
